// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import {
  Ln2MessageLookupData,
  Ln2MessageLookupDataT,
  verifyLn2MessageLookupData,
} from "./ln2-message-lookup-data";
import { PinMappingKey, PinMappingKeyT, verifyPinMappingKey } from "./pin-mapping-key";

export class DiscreteToLn2Entry implements flatbuffers.IUnpackableObject<DiscreteToLn2EntryT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): DiscreteToLn2Entry {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsDiscreteToLn2Entry(
    bb: flatbuffers.ByteBuffer,
    obj?: DiscreteToLn2Entry,
  ): DiscreteToLn2Entry {
    return (obj || new DiscreteToLn2Entry()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsDiscreteToLn2Entry(
    bb: flatbuffers.ByteBuffer,
    obj?: DiscreteToLn2Entry,
  ): DiscreteToLn2Entry {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new DiscreteToLn2Entry()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  key(obj?: PinMappingKey): PinMappingKey | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new PinMappingKey()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  value(obj?: Ln2MessageLookupData): Ln2MessageLookupData | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new Ln2MessageLookupData()).__init(
          this.bb!.__indirect(this.bb_pos + offset),
          this.bb!,
        )
      : null;
  }

  static startDiscreteToLn2Entry(builder: flatbuffers.Builder) {
    builder.startObject(2);
  }

  static addKey(builder: flatbuffers.Builder, keyOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, keyOffset, 0);
  }

  static addValue(builder: flatbuffers.Builder, valueOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, valueOffset, 0);
  }

  static endDiscreteToLn2Entry(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // key
    builder.requiredField(offset, 6); // value
    return offset;
  }

  unpack(): DiscreteToLn2EntryT {
    return new DiscreteToLn2EntryT(
      this.key() !== null ? this.key()!.unpack() : null,
      this.value() !== null ? this.value()!.unpack() : null,
    );
  }

  unpackTo(_o: DiscreteToLn2EntryT): void {
    _o.key = this.key() !== null ? this.key()!.unpack() : null;
    _o.value = this.value() !== null ? this.value()!.unpack() : null;
  }

  unpackFields(...fields: string[]): DiscreteToLn2EntryT {
    const t = new DiscreteToLn2EntryT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("key")) {
      t.key = this.key() !== null ? this.key()!.unpack() : null;
    }
    if (fieldSet.has("value")) {
      t.value = this.value() !== null ? this.value()!.unpack() : null;
    }
    return t;
  }
}

export class DiscreteToLn2EntryT implements flatbuffers.IGeneratedObject {
  constructor(
    public key: PinMappingKeyT | null = null,
    public value: Ln2MessageLookupDataT | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.key === null || this.key === undefined) {
      throw new Error('Required field "key" is not set');
    }
    if (this.value === null || this.value === undefined) {
      throw new Error('Required field "value" is not set');
    }
    const key = this.key !== null ? this.key!.pack(builder) : 0;
    const value = this.value !== null ? this.value!.pack(builder) : 0;

    DiscreteToLn2Entry.startDiscreteToLn2Entry(builder);
    DiscreteToLn2Entry.addKey(builder, key);
    DiscreteToLn2Entry.addValue(builder, value);

    return DiscreteToLn2Entry.endDiscreteToLn2Entry(builder);
  }

  clone(): DiscreteToLn2EntryT {
    const obj = new DiscreteToLn2EntryT();
    obj.key = this.key !== null ? this.key!.clone() : null;
    obj.value = this.value !== null ? this.value!.clone() : null;
    return obj;
  }

  equals(other: DiscreteToLn2EntryT): boolean {
    if (this.key !== null && other.key !== null) {
      if (!this.key!.equals(other.key!)) return false;
    } else if (this.key !== other.key) return false;
    if (this.value !== null && other.value !== null) {
      if (!this.value!.equals(other.value!)) return false;
    } else if (this.value !== other.value) return false;
    return true;
  }
}

export function verifyDiscreteToLn2Entry(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyPinMappingKey(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "key");
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 6);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyLn2MessageLookupData(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "value");
  } finally {
    verifier.popDepth();
  }
}
